import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route key="/consumer/features/double-chin-remover" element={<DefaultConsumerLayout />}>
    <Route path="consumer/features/double-chin-remover" element={<AsyncPage />} />
  </Route>
);
